import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LayersIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brand, heroBadges, heroImage } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-white pb-16 pt-12 md:pb-24 md:pt-16" data-id="element-140" data-mp="4lqjwydxzh4k">
      <div className="mx-auto w-full max-w-5xl px-5 text-center md:px-8" data-id="element-141" data-mp="4njnu5x67n8v">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-blue-600 md:text-base" data-id="element-142" data-mp="12861e06dces4">
          <LayersIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-143" data-mp="nczvreb6qhzb" />
          {brand.name}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl text-4xl font-extrabold leading-tight tracking-tight text-gray-900 sm:text-5xl md:text-6xl" data-id="element-144" data-mp="3d2bkprwf73wl">
          {brand.promise}
          <br data-id="element-145" data-mp="3o5j1b4tkf9j6" />
          <span className="text-blue-600" data-id="element-146" data-mp="39acwuma4biry">{brand.promiseAccent}</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease
      }} src={heroImage} alt="" className="mx-auto mt-10 w-full max-w-2xl" width={1240} height={1240} data-id="element-147" data-mp="39cpa4m4xl4yo" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.18,
        ease
      }} className="mx-auto mt-10 max-w-3xl" data-id="element-148" data-mp="2qkdboaheentt">
          <p className="text-xl leading-relaxed text-gray-700 md:text-2xl" data-id="element-149" data-mp="2hk85g3nxxvh8">{brand.subtitle}</p>

          <p className="mt-8 text-lg font-extrabold tracking-tight text-gray-900 md:text-xl" data-id="element-150" data-mp="2ljpa4uvjmolc">
            {brand.system}
          </p>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-gray-600" data-id="element-151" data-mp="s44hnmgsjjhd">
            {heroBadges.map(badge => <li key={badge} className="inline-flex items-center gap-1.5" data-id="element-152" data-mp="id02aln7dwm0">
                <CheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-153" data-mp="ddwwgyzefmcz" />
                {badge}
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-154" data-mp="1ayt6mzo5djaw">
            <CtaButton size="xl" className="w-full max-w-2xl" href="#muestras" data-id="element-155" data-mp="161ayhbhyf83y">
              {brand.heroCta}
            </CtaButton>
          </div>
        </motion.div>
      </div>
    </section>;
}